import styled from 'styled-components';

export const TableWrapper = styled.div`
.ag-header-cell-text {
    font-size: 12px !important;
    // text-transform: uppercase;
    justify-content: center !important;
}
.ag-header-cell
  font-size: 11px !important;
  justify-content: center !important;
}

.ag-header-cell-label {
  justify-content: center;
}

.ag-cell-label {
  justify-content: center !important;
}

.ag-cell {
  display: flex;
  justify-content: center !important;

}

.ag-theme-alpine .ag-row-group {
  // background-color: #ebedef;
}

.ag-theme-alpine .ag-row-group-level-0 {
  font-weight: bold;
}

.ag-row-hover {
  background-color: #f2f2f2 !important;  /* Change to your preferred color */
}

.ag-theme-alpine div.ag-row {

    // --ag-background-color: rgb( 247, 251, 244);
    // --ag-header-foreground-color: rgb(204, 245, 172);
    // --ag-odd-row-background-color: rgb(0, 0, 0, 0.03);
    // --ag-header-column-resize-handle-color: rgb(126, 46, 132);

    // font-family: arial;
    font-size: 12px !important;
    justify-content: right !important;

    // font-family: 'gulim';
    // font-size: 12px !important;
    // font-weight: bold !important;

}
`
